import { createToaster } from "@meforma/vue-toaster";
class CommonUses {
    uploadImageFileValidator($file) {
        if ($file.target.files.length > 0) {
            const fileName = $file.target.files[0].name;
            const extensions = [".png", ".jpeg", ".jpg", ".gif"];
            let blnValid = false; let isUploadImageValid = false
            for (var j = 0; j < extensions.length; j++) {
                var sCurExtension = extensions[j];
                if (fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) { blnValid = true; break; }
            }
            if (!blnValid) {
                //$file.target.value = "";
                const toaster = createToaster({ position: 'top-right' });

                toaster.error(`Valid file format is ${extensions.join(", ")}`);
                isUploadImageValid = false
                return isUploadImageValid;
            }
            else {
                isUploadImageValid = true;
                return isUploadImageValid;
            }
        }
        else {
            let isUploadImageValid = false
            return isUploadImageValid;
        }
        

    }



    uploadLoanImageFileValidator($file) {
        const fileName = $file.target.files[0].name;
        const extensions = [ "txt", ".xlsx",".xls",".pdf",".doc",".docx",".bmp",".png",".jpg",".jpeg",".gif" ];
        let blnValid = false; let isUploadImageValid = false
        for (var j = 0; j < extensions.length; j++) {
            var sCurExtension = extensions[j];
            if (fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) { blnValid = true; break; }
        }
        if (!blnValid) {
            //$file.target.value = "";
            const toaster = createToaster({ position: 'top-right' });

            toaster.error(`Valid file format is ${extensions.join(", ")}`);
            isUploadImageValid = false
            return isUploadImageValid;
        }
        else {
            isUploadImageValid = true;
            return isUploadImageValid;
        }

    }


    uploadDocumenteFileValidator($file) {
        const fileName = $file.target.files[0].name;
        const extensions = [".pdf", ".xlsx", ".csv", ".docx", ".doc", ".pptx", ".ppt", ".txt", "xls"];
        let blnValid = false; let isUploadImageValid = false
        for (var j = 0; j < extensions.length; j++) {
            var sCurExtension = extensions[j];
            if (fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) { blnValid = true; break; }
        }
        if (!blnValid) {
            //$file.target.value = "";
            const toaster = createToaster({ position: 'top-right' });

            toaster.error(`Valid file format is ${extensions.join(", ")}`);
            isUploadImageValid = false
            return isUploadImageValid;
        }
        else {
            isUploadImageValid = true;
            return isUploadImageValid;
        }

    }

    uploadVideoFileValidator($file) {
        const fileName = $file.target.files[0].name;
        const extensions = [".mp4"];
        let blnValid = false;
        let isUploadImageValid = false
        for (var j = 0; j < extensions.length; j++) {
            var sCurExtension = extensions[j];
            if (fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) { blnValid = true; break; }
        }
        if (!blnValid) {
            //$file.target.value = "";
            const toaster = createToaster({ position: 'top-right' });

            toaster.error(`Valid file format is ${extensions.join(", ")}`);
            isUploadImageValid = false
            return isUploadImageValid;
        }
        else {
            isUploadImageValid = true;
            return isUploadImageValid;
        }

    }
    TrainingMPAndPdfAndDocFileValidator($file) {

        const fileName = $file.target.files[0].name;
        const currentfileextension = fileName.substring(fileName.lastIndexOf('.') + 1);
        const extensions = ["doc", "docx", "pdf", "mp4", "avi", "mp3"];
        let blnValid = false; this.isUploadImageValid = false;
        for (var j = 0; j < extensions.length; j++) {
            if (currentfileextension.toLowerCase() == extensions[j].toLowerCase()) { blnValid = true; break; }
        }
        if (!blnValid) {
            $file.target.value = "";
            const toaster = createToaster({ position: 'top-right' });

            toaster.error(`Valid file format is ${extensions.join(", ")}`);

        }
        else {
            this.isUploadImageValid = true;
        }
        return this.isUploadImageValid;
    }
    AllFileValidator($file) {
        debugger
        const fileName = $file.target.files[0].name;
        const currentfileextension = fileName.substring(fileName.lastIndexOf('.') + 1);
        const extensions = ["doc", "docx", "pdf", "mp4", "avi", "mp3", "png", "jpeg", "jpg", "gif", "xlsx"];
        let blnValid = false; this.isUploadImageValid = false;
        for (var j = 0; j < extensions.length; j++) {
            if (currentfileextension.toLowerCase() == extensions[j].toLowerCase()) { blnValid = true; break; }
        }
        if (!blnValid) {
            $file.target.value = "";
            const toaster = createToaster({ position: 'top-right' });

            toaster.error(`Valid file format is ${extensions.join(", ")}`);

        }
        else {
            this.isUploadImageValid = true;
        }
        return this.isUploadImageValid;
    }
    findModuleByCode(modules, moduleCode) {
        if (!Array.isArray(modules) || moduleCode == null || moduleCode === '') {
            return null;
        }
        for (let i = 0; i < modules.length; i++) {
            const mod = modules[i];
            if (mod == null) {
                continue;
            }
            if (mod.moduleCode == moduleCode) {
                return mod;
            }
            const fromSub = this.findModuleByCode(mod.subModules, moduleCode);
            if (fromSub) {
                return fromSub;
            }
            const fromCategory = this.findModuleByCode(mod.categoryModules, moduleCode);
            if (fromCategory) {
                return fromCategory;
            }
        }
        return null;
    }

    getPermission(moduleCode) {
        const moduledata = JSON.parse(localStorage.getItem('moduleList'));

        if (moduledata !== null && typeof moduledata !== 'undefined') {
            let module1 = this.findModuleByCode(moduledata, moduleCode);
            if (module1 == undefined || module1 == null) {
                module1 = "null";
            }

            return module1;
        }
        else {
            return null;
        }
    }

    uploadDocumentSize(type, filesize, filelength) {
        debugger;
        let isFileValid;
        if (filelength == "30MB") {
            let isFileValid = false;
            if (type.toLowerCase() !== '') {
                if (filesize >= 30000000) {    // 30MB Size in Bytes.
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 30MB.");

                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }

        }
        else if (filelength == "10MB") {

            if (type.toLowerCase() !== '') {
                if (filesize >= 10485760) { //10MB Size in Bytes.
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 10MB.");

                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
        else if (filelength == "50MB") {

            if (type.toLowerCase() !== '') {
                if (filesize >= 10485760) { //10MB Size in Bytes.
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 50MB.");

                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
        else if (filelength == "5MB") {

            if (type.toLowerCase() !== '') {
                if (filesize >= 5242880) { //10MB Size in Bytes.
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 5MB.");

                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
        else if (filelength == "1KB") {
            if (type.toLowerCase() !== '') {
                if (filesize >= 1000000) { //10MB Size in Bytes.
                    /* this.$toast.error("Please upload a file of max. size 1kKB.");*/
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 1kKB.");
                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
        else {
            if (type.toLowerCase() !== '') {
                if (filesize >= 5242880) {//5MB Size in Bytes.1, 000, 000
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 5MB.");
                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
    }

    uploadDocCheckincheckoutSize(type, filesize, filelength) {
        debugger;
        let isFileValid;
        
         if (filelength == "10MB") {

            if (type.toLowerCase() !== '') {
                if (filesize >= 10485760) { //10MB Size in Bytes.
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 10MB.");

                    isFileValid = false;
                    return isFileValid;
                }
                else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
         else
         {
            if (type.toLowerCase() !== '') {
                if (filesize >= 10485760) { // 10MB Size in Bytes
                    const toaster = createToaster({ position: 'top-right' });

                    toaster.error("Please upload a file of max. size 10MB.");
                    isFileValid = false;
                    return isFileValid;
                } else {
                    isFileValid = true;
                    return isFileValid;
                }
            }
        }
    }





    validUploadDocumentType(name, validType) {
        let isFileValid;
        let splitstr = name.toLowerCase().split('.').reverse();
        let ext = splitstr.length > 0 ? splitstr[0] : '';
        if (splitstr.length > 0 && validType.includes(ext))
            isFileValid = true;
        else {
            isFileValid = false;
        }
        return isFileValid;
    }
    validUploadDocumentSize(filesize, maxSize) {
        let isFileValid;
        let maxSizebt = maxSize * 1048576;
        if (filesize <= maxSizebt) {
            isFileValid = true;
        } else {
            isFileValid = false;
        }
        return isFileValid;
    }
    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }
    async GetIPAddress() {
        const response = await fetch('https://api.ipify.org?format=json');
        const data_res = await response.json();
        if (data_res != null) {
            return await data_res.ip;
        }
        else {
            return await "::1";
        }

    }
}

export default new CommonUses();